module.exports = __webpack_public_path__ + "static/apple_splash_1242-dd906c699268a9d51fbfbdda8ce98067.png";